import http from 'conversations-http/clients/http';
export const unassignResponder = ({
  threadId
}) => http.delete(`conversations-assignments/v1/assignments/${threadId}`);